<med-label
  mode="column"
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
>
  <div
    [ngClass]="inputClass"
    class="med-checkbox"
  >
    <input
      [tabIndex]="tabindex"
      type="checkbox"
      class="med-checkbox__input"
      [id]="name"
      [name]="name"
      [disabled]="disabled"
      [required]="required"
      [(ngModel)]="value"
      (blur)="onBlur.emit($event)"
      (focus)="emitFocus($event)"
      (change)="onInput.emit($any($event))"
    />

    <div
      [ngClass]="classList"
      class="field med-checkbox__box"
    >
      <div class="med-checkbox__icon">
        <med-icon-check size="16"></med-icon-check>
      </div>
    </div>
  </div>
</med-label>

<div
  *ngIf="invalid"
  class="field__error-message"
>
  {{ errorMessage }}
</div>
